export default __webpack_public_path__ + "static/media/shaddi.51f0535d.svg";